import { phone } from '@polvo-labs/form-utils'
import { useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../components/Button'
import Modal from '../../../components/Modal'
import Private from '../../../components/Private'
import Text from '../../../components/Text'
import { REALTY_OPTION_TYPE } from '../../../config/realty-types'
import routes from '../../../config/routes'
import AccountForm from '../../../forms/UserData'
import RealtyCreateForm from '../../../forms/Realty/Create'
import { Actions, ModalContent } from './styles'

interface Props {

}

const RealtyCreateScreen: React.FC<Props> = () => {
  const [wantsToSell, setWantsToSell] = useState<boolean | undefined>(undefined)

  const [step, setStep] = useState<number>(1)
  const [currentType, setCurrentType] = useState<REALTY_OPTION_TYPE | undefined>(undefined)
  const history = useHistory()

  const [realtyTypes, setRealtyTypes] = useState<REALTY_OPTION_TYPE[]>([])
  const { token, user } = useAuth()


  const needUser = () =>{
    let resp = false
    const fields = ['birth_year',
      'city',
      'cpf',
      'email',
      'name',
      'phone',
    ]
    fields.forEach(field => {
      if (user[field] === null || user[field] === '')
        resp = true
    })
    return resp

  }

  useEffect(() => {
    let mounted = true
    Axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/realty_types`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((data) => {
      if (mounted) {
        const types: REALTY_OPTION_TYPE[] = []

        data.data.data.forEach((item: any) => {
          types.push({ label: item.type, value: item.id })
        })

        setRealtyTypes(types)
      }
    })
    return () => {
      mounted = false
    }
  }, [])

  return (
    <>
      <Private>
        <div>
          <div
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Text
              style={{ maxWidth: '50%' }}
              tag="h1"
            >
              Cadastrar imóvel com dívida
            </Text>
            <Button
              style={{ marginLeft: 'auto' }}
              label="Listar imóvel"
              backgroundColor="darkBlue"
              fontColor="white"
              borderColor="lightGray"
              small
              onClick={() => {
                history.push(routes.realty.index.path)
              }}
            />
          </div>
          {/* {needUser() ? (<>
            <AccountForm
              initialValues={user}
            />
          </>) : ''} */}
          <div>

            <Text
              style={{ maxWidth: '50%' }}
              tag="h2"
            >
              Dados do imóvel
            </Text>

            <Text
              tag="h2"
              color="darkGray"
            >
              Tem interesse em vender o imóvel?
            </Text>

            <Actions>
              <Button
                // disabled={needUser()}
                label="SIM"
                backgroundColor={wantsToSell === true ? 'blue' : 'white'}
                fontColor={wantsToSell === true ? 'white' : 'darkGray'}
                borderColor={wantsToSell === true ? 'blue' : 'lightGray'}
                onClick={() => {
                  setWantsToSell(true)
                  if (step < 2)
                    setStep(2)
                }}
                block
              />

              <Button
                label="NÃO"
                backgroundColor={wantsToSell === false ? 'blue' : 'white'}
                fontColor={wantsToSell === false ? 'white' : 'darkGray'}
                borderColor={wantsToSell === false ? 'blue' : 'lightGray'}
                onClick={() => {
                  setWantsToSell (false)
                  setStep(1)
                }}
                block
              />
            </Actions>

            <p
              style={
                {fontFamily: 'Roboto',
                  fontSize: '16px',
                  lineHeight: '19px',
                  textAlign: 'left',
                  color: '#606060'}
              }
            >
              A plataforma IPTU.APP não serve para a consulta de débitos de imposto, emissão de guia amarela ou qualquer assunto relacionado à renegociação de débitos. Em caso de dúvidas acesse o <a
                href="https://cdn.iptu.app/assets/docs/manual-usuario-iptu.pdf"
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
              >MANUAL DO USUÁRIO</a>
            </p>
          </div>
          <div
            hidden={step < 2}
          >
            <Text
              tag="h2"
              color="darkGray"
            >
              Selecione o tipo
            </Text>
            {realtyTypes.map((type: REALTY_OPTION_TYPE, index) => {
              return (
                <Button
                  key={`buttons_${index}`}
                  style={{ margin: '10px' }}
                  label={type.label}
                  backgroundColor={type === currentType ? 'blue' : 'white'}
                  fontColor={type === currentType ? 'white' : 'darkGray'}
                  borderColor={type === currentType ? 'blue' : 'lightGray'}
                  onClick={() => {
                    setCurrentType(type)
                    setStep(3)
                  }}
                />
              )
            })}
          </div>
          <div
            hidden={step < 3}
          >
            {wantsToSell === undefined ? (
              <div></div>
            ) : wantsToSell ? (
              <>
                <Text
                  tag="h2"
                  color="darkGray"
                >
                  Detalhes
                </Text>
                <RealtyCreateForm
                  type={currentType}
                  onSubmit={() => {
                    history.push(routes.realty.index.path+'?created=true')
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                  }}
                />
                <div
                  style={{ marginTop: '20px', marginBottom: '40px' }}
                >
                </div>
              </>
            ) : (
              <Modal
                open
                small
                onToggle={() => setWantsToSell(undefined)}
              >
                <ModalContent>
                  <Text
                    tag="h2"
                    align="center"
                  >
                        CADASTRO DE IMÓVEL NEGADO
                  </Text>

                  <Text
                    tag="p"
                    color="darkGray"
                  >
                        Recebemos a informação de que não possui interesse em cadastrar imóvel para venda.
                        Atualmente a plataforma IPTU.APP tem o objetivo de viabilizar compra de imóveis com dívida ativa. Caso
                        tenha interesse em vender seu imóvel, por favor, realize o cadastro e entre em contato conosco.
                  </Text>

                  <Button
                    label="ENTENDI"
                    onClick={() => setWantsToSell(undefined)}
                  />
                </ModalContent>
              </Modal>
            )}
          </div>

        </div>
      </Private>
    </>
  )
}

export default RealtyCreateScreen
